<axs-input
  [axsError]="inputError"
  [axsDisplayValue]="currentDisplayValue"
  [axsDesignType]="designType"
  style="background: transparent">
  <input
    class="axs-input-asset-dollar"
    slot="input"
    type="text"
    inputmode="decimal"
    name="{{name}}"
    id="{{id}}"
    style="text-align: left"
    [attr.aria-invalid]="inputError? 'true' : null"
    [attr.aria-labelledby]="ariaLabelId"
    (input)="onInput($event)"
    [(ngModel)]="currentValue"
    [ngModelOptions]="{standalone: true}"
    placeholder="{{placeholder}}"
  />
  @if (!inputError && (hintText != '' || (differsText != '' && inputDiffers))) {
    <div class='axs-input-hint-v4'
         id="{{id}}__hint"
         [ngClass]="{'differsText':inputDiffers}"
         slot="hint">
      <ngx-axs-icon
        [axsType]="inputDiffers?'infoSolid':'infoOutline'"
        axsAriaLabel="information"
        [axsWidth]="16"
      ></ngx-axs-icon>
      <span id="{{id}}__hint-text">
         @if (inputDiffers) {
           {{ differsText }} <span class="axs-link" (click)="differsLinkClick()">{{ differsLinkText }}</span>
         } @else {
           {{ hintText }}
         }
      </span>
    </div>
  }
  @if (inputError) {
    <div class='axs-input-error axs-input-error-v4'
         id="{{id}}__error"
         slot="error">
      <ngx-axs-icon
        axsType="warningSolid"
        axsAriaLabel="error"
        [axsWidth]="16"
      ></ngx-axs-icon>
      <span id="{{id}}__error-text">{{ errorText }}</span>
    </div>
  }
</axs-input>
